import userConstants from './ActionType';


const request = user => ({ type: userConstants.LOGIN_REQUEST, user });
const success = user => ({ type: userConstants.LOGIN_SUCCESS, user });
const failure = error => ({ type: userConstants.LOGIN_FAILURE, error });
const failure401 = error => ({ type: userConstants.LOGIN_FAILURE_401, error });
const failureSyncRequired = error => ({ type: userConstants.LOGIN_FAILURE_SYNC_REQUIRED, error });
const apiError = error => ({ type: userConstants.USERS_API_FAILS, error });
const logout = user => ({ type: userConstants.LOGOUT, user });
const token = apiToken => ({ type: userConstants.API_TOKEN, apiToken });
const myCompanyPermission = accessPermission => ({ type: userConstants.MY_COMPANY_PERMISSION, accessPermission });
const returnsAllowableFileSize = accessPermission => ({ type: userConstants.AWSS3_MAX_ALLOWABLE_FILE_SIZE, accessPermission });
const returnsAllowableFiles = accessPermission => ({ type: userConstants.AWSS3_MAX_ALLOWABLE_FILES, accessPermission });
const returnsAllowableFileTypes = accessPermission => ({ type: userConstants.AWSS3_MAX_ALLOWABLE_FILE_TYPES, accessPermission });
const ctoAllowableCustomers = accessPermission => ({ type: userConstants.CTO_ALLOWABLE_CUSTOMERS, accessPermission });
const reOrderExcludeItems = accessPermission => ({ type: userConstants.REORDER_EXCLUDE_ITEMS, accessPermission });
const myAccountPermission = accessPermission => ({ type: userConstants.MY_ACCOUNT_PERMISSION, accessPermission });
const myCompanyAdminRoleCount = accessPermission => ({ type: userConstants.MY_COMPANY_ADMIN_ROLE_COUNT, accessPermission });
const itemLimitCount = accessPermission => ({ type: userConstants.ITEM_LIMIT_COUNT, accessPermission });
const backOrderedFlag = accessPermission => ({ type: userConstants.BACK_ORDERED_FLAG, accessPermission });
const globalDateFormat = accessPermission => ({ type: userConstants.GLOBAL_DATE_FORMAT, accessPermission });
const globalPhoneFormat = accessPermission => ({ type: userConstants.GLOBAL_PHONE_FORMAT, accessPermission });
const freightDetails = accessPermission => ({ type: userConstants.FREIGHT_DETAILS, accessPermission });
const isCoveoSearchEnabled = accessPermission => ({ type: userConstants.IS_COVEO_SEARCH_ENABLED, accessPermission });
const sleepLabPermission = accessPermission => ({ type: userConstants.SLEEPlAB_LOCATOR_PERMISSION, accessPermission });
const dealerLocatorPremission = accessPermission => ({ type: userConstants.DEALER_LOCATOR_PERMISSION, accessPermission });
const orderReviewAccountNumber = accessPermission => ({ type: userConstants.ORDER_REVIEW_ACCOUNT_NUMBER, accessPermission });
const getLocalLang = accessPermission => ({ type: userConstants.LOCALE_LANG_SET, accessPermission });
const getRequestTypes = orderTypes => ({ type: userConstants.GET_REQUEST_TYPE, orderTypes });
const getUserList = userList => ({ type: userConstants.GET_ALL_USER_LIST, userList });
const setUserFlag = (key, value) => ({ type: userConstants.SET_USER_FLAG, key, value });
const setMarketingBannerData = payload => ({ type: userConstants.SET_MARKETING_BANNER_DATA, payload });
const setFooterTopMargin = payload => ({ type: userConstants.SET_FOOTER_TOP_MARGIN, payload });
const setHasMultipleAccounts = hasMultipleAccounts => ({ type: userConstants.SET_HAS_MULTIPLE_ACCOUNTS, hasMultipleAccounts });

export default {
  logout,
  request,
  success,
  failure,
  failure401,
  failureSyncRequired,
  token,
  myCompanyPermission,
  returnsAllowableFileSize,
  returnsAllowableFiles,
  returnsAllowableFileTypes,
  ctoAllowableCustomers,
  reOrderExcludeItems,
  myAccountPermission,
  myCompanyAdminRoleCount,
  itemLimitCount,
  backOrderedFlag,
  globalDateFormat,
  globalPhoneFormat,
  freightDetails,
  isCoveoSearchEnabled,
  sleepLabPermission,
  dealerLocatorPremission,
  orderReviewAccountNumber,
  getRequestTypes,
  getUserList,
  getLocalLang,
  apiError,
  setUserFlag,
  setMarketingBannerData,
  setFooterTopMargin,
  setHasMultipleAccounts
};
